module.exports = __webpack_public_path__ + "static/media/bars.d1046941.svg";